import dayjs from 'dayjs';

import styles from './styles.module.scss';
import { ReactComponent as WindIcon } from './assets/icons/wind.svg';

import { DateLlFormat } from '../../constants/data';
import { BreakpointTablet } from '../../constants/ui';

const WeatherCard = ({ t, params, widthViewport }) => {
  return (
    <div className={styles.weatherCard}>
      <div className={styles.weatherCardHero}>
        <time className={styles.weatherCardDate}>{dayjs(params.date).format(DateLlFormat)}</time>
        <figure className={styles.weatherCardIcon}>
          <img src={params.iconSrc} alt={params.description} width={32} height={32} />
        </figure>

        {/*Temperature*/}
        {widthViewport > BreakpointTablet ? (
          <div className={styles.weatherCardTemperature}>
            {params.temperature.min > 0 && '+'}
            <span>{params.temperature.min}</span>°...{params.temperature.min > 0 && '+'}
            <span>{params.temperature.max}</span>°C
          </div>
        ) : (
          <div className={styles.weatherCardTemperature}>
            <span>{params.temperature.min > 0 && '+' + params.temperature.min}</span>
            <span>{params.temperature.min > 0 && '+' + params.temperature.max}</span>
          </div>
        )}
      </div>

      {/*Precipitation*/}
      <div className={styles.weatherCardParam}>
        {params.code && <span className={styles.weatherCardParamTitle}>{t(`weather.${params.code}`)}</span>}
        <div>{params.precipitation.toFixed(0)} mm</div>
      </div>

      {/*Wind*/}
      <div className={styles.weatherCardParam}>
        <span className={styles.weatherCardParamTitle}>{t('weather.wind')}</span>
        <div className={styles.weatherCardParamRow}>
          {params.windDirection !== null && (
            <div className={styles.weatherCardParamIcon} style={{ transform: `rotate(${params.windDirection}deg)` }}>
              <WindIcon />
            </div>
          )}
          <div>{params.windSpeed} m/s</div>
        </div>
      </div>
    </div>
  );
};

export default WeatherCard;
